import React from 'react';
import FormatPixel from '../utils/formatPixel';
export default function Introduction({ title, description, eventDescription }) {

    const descriptionPara = description.split('\n\n')


    return (
        <div className='intro--wrapper'>
            <div className='intro--image'>

            </div>
            <div className='flex flex-col mb-[150px]'>
                <div className='flex ju-end md:block' >
                    <div className='max-500 left-gradient pl30'>

                        <h2 className='mb-[50px]'><FormatPixel text={title} /></h2>
                        <div dangerouslySetInnerHTML={{__html:description.replaceAll('\n','<br/>')}}>
                           
                        </div>

                    </div>
                </div>
                <div>

                </div>
            </div>

            <div className='flex justify-start md:block '>
                <div className='max-w-500 mb-[100px]  '>
                    <h2 className=''><FormatPixel text={eventDescription} /></h2>
                </div>
            </div>

        </div>
    );
}
